import { RootAction } from "../RootAction";

export const setActiveAll = () => {
  return {
      type: RootAction.ActionState.SetActiveAll,
  }
}

export const setDisableAll = () => {
  return {
      type: RootAction.ActionState.SetDisableAll,
  }
}

export const setActiveById = (ids) => {
  return {
      type: RootAction.ActionState.SetActiveById,
      data: {
        Ids: ids
      }
  }
}

export const setDisableById = (ids) => {
  return {
      type: RootAction.ActionState.SetDisableById,
      data: {
        Ids: ids
      }
  }
}